<template>
  <div>
    <div>
      <!-- Name Input  -->
      <div class="col form-group mb-4">
        <input
          ref="nameInput"
          id="name"
          v-model="obj.firstName"
          class="w-100"
          :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
          :placeholder="obj.name ? obj.name : placeholders.fullName"
          type="text"
        />
      </div>

      <!-- Last Name Input -->
      <div class="col form-group mt-5">
        <input
          ref="nameInput"
          id="socialName"
          v-model="obj.socialName"
          class="w-100"
          :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
          :placeholder="placeholders.beCalled"
          type="text"
          @keyup.enter="validateFields"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* State */
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'Name',
  props: {
    validate: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    obj: {},
  }),
  computed: {
    ...mapState(['config', 'registrationObject', 'subdomain', 'template']),
    placeholders() {
      if (this.obj.passport) {
        return {
          fullName: 'Full Name',
          beCalled: 'What would you like to be called?',
        }
      }
      return {
        fullName: 'Nome completo',
        beCalled: 'Como você gostaria de ser chamado(a)',
      }
    },
  },
  watch: {
    validate(newValue) {
      if (newValue) this.validateFields()
    },
  },
  methods: {
    ...mapMutations([
      'addRegistrationError',
      'clearRegistrationErrors',
      'updateRegistrationObject',
    ]),
    validateFields() {
      this.$emit('validating')

      this.clearRegistrationErrors()

      let hasErrors = false

      let nameFull = this.obj.firstName.split(' ')

      if (nameFull.length <= 1) {
        hasErrors = true

        this.addRegistrationError({
          msg: this.obj.passport
            ? 'You must provide your full name.'
            : 'É necessário informar seu nome completo.',
        })
      }

      if (!this.obj.firstName) {
        hasErrors = true

        this.addRegistrationError({
          msg: 'É necessário informar seu nome.',
        })
      }

      if (!this.obj.socialName) {
        hasErrors = true

        this.addRegistrationError({
          msg: this.obj.passport
            ? 'You must inform how you would like to be called.'
            : 'É necessário informar como gostaria de ser chamado(a).',
        })
      }

      if (!hasErrors) {
        this.$store.commit('updateRegistrationObject', this.obj)

        this.$emit('next')
      }
    },
  },
  mounted() {
    // Creates a deep copy of the object in the store
    this.obj = JSON.parse(JSON.stringify(this.registrationObject))

    document.getElementById('name').focus()
  },
}
</script>
